import Cookies from "js-cookie";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);


export default class Main {
    constructor() {
        this.init();
    }

    init() {
        window.addEventListener('unload', () => window.scrollTo(0, 0));
        this.owl();
        this.lightcase();

        //初回アニメーション
        if (!Cookies.get('visited')) this.intro();
        else this.mvAnimation(); //5th MV
        //else this.mvanimation(); //4th MV
    }

    intro() {
        const scalesize = window.innerWidth < 768 ? '200vw' : '100vw';

        const tl = gsap.timeline({});
        tl.set('.mainvisual__effect,.mainvisual__txt_wrap', { display: 'block' });
        tl.set('.mainvisual__line', { height: '100%', rotation: '-180deg', display: 'block' });
        tl.set('.mainvisual__curtain', { height: '100%', rotation: '180deg' });

        tl.to('.mainvisual__curtain', { duration: 0.4, rotation: '0deg', x: '-50%', y: '-50%', height: '0', ease: 'Circ.easeInOut' }, 0.5);
        tl.to('.mainvisual__line', { duration: 0.4, rotation: '0deg', x: '-50%', y: '-50%', height: '0.5vw', ease: 'Circ.easeInOut' }, 0.6);
        tl.to('.mainvisual__line', { duration: 0.4, width: '5.5vw', left: '57.5%', ease: 'Circ.easeInOut' }, 1.2);
        tl.to(
            '.mainvisual__txt__item.-p,.mainvisual__txt__item.-a,.mainvisual__txt__item.-r,.mainvisual__txt__item.-d,.mainvisual__txt__item.-l,.mainvisual__txt__item.-i,.mainvisual__txt__item.-v,.mainvisual__txt__item.-e',
            { duration: 0.8, marginRight: '0', ease: 'Circ.easeInOut' },
            0.5
        );
        tl.to('.mainvisual__txt__item.-o', { duration: 0.8, marginRight: '5vw', ease: 'Circ.easeInOut' }, 0.5);
        tl.to('.mainvisual__txt__item.-x', { duration: 0.8, left: '51.5%', ease: 'Circ.easeInOut' }, 0.5);

        tl.to('.mainvisual__txt__item.-x', { duration: 0.8, width: scalesize, height: scalesize, ease: 'Circ.easeInOut' }, 1.5);
        tl.to(
            '.mainvisual__txt__item.-p,.mainvisual__txt__item.-a,.mainvisual__txt__item.-r,.mainvisual__txt__item.-d,.mainvisual__txt__item.-o,.mainvisual__txt__item.-l,.mainvisual__txt__item.-i,.mainvisual__txt__item.-v,.mainvisual__txt__item.-e',
            { duration: 0.8, marginRight: '10vw', scale: 3, ease: 'Circ.easeInOut' },
            1.5
        );

        tl.to(
            '.mainvisual__txt__item.-p,.mainvisual__txt__item.-a,.mainvisual__txt__item.-r,.mainvisual__txt__item.-d,.mainvisual__txt__item.-o,.mainvisual__txt__item.-l,.mainvisual__txt__item.-i,.mainvisual__txt__item.-v,.mainvisual__txt__item.-e,.mainvisual__line',
            { duration: 0.5, opacity: 0, display: 'none' },
            2.5
        );
        tl.to('.mainvisual__txt__item.-x', 0.3, { duration: 0.3, width: '1000vw', height: '1000vw', opacity: 0, display: 'none' }, 2.5);
        tl.call(
            () => {
                $('.mainvisual__effect').addClass('-active');
            },
            null,
            0.5
        );

        //終了後
        //tl.call(()=>{ this.mvanimation(); }, null, 2.5 ); //4th MV
        tl.call(
            () => {
                this.mvAnimation();
            },
            null,
            2.5
        ); //5th MV

        Cookies.set('visited', 1, { expires: 1 });
    }

    owl() {
        $('.owl-carousel').owlCarousel({
            loop: true,
            autoplay: true,
            items: 1,
            dots: true,
        });
    }

    lightcase() {
        $('.js-lightcase').lightcase();
    }

    //4th MV
    /* mvanimation() {
        const curtain = document.querySelector(".mainvisual__curtain");
        const layer = document.querySelector(".mainvisual__layer");
        const tl = new gsap.timeline();

        tl.to(curtain, { duration: 0.6, opacity: 0, display: "none" });
        if(window.innerWidth >= 769){
            tl.to(window, { duration: 2, scrollTo: layer.clientHeight * 0.45, ease: "power4.inOut" });
        }
    } */

    //5th MV
    mvAnimation() {
        const mainvisual = document.querySelector('.mainvisual');
        const layer = document.querySelector('.mainvisual__layer');

        document.body.classList.add('-introend');

        layer.addEventListener('animationend', () => {
            document.body.classList.add('-moveactive');
        });
    }
}
